<template>
  <div class="dialog-scroll">
    <div class="viewable-area-style">
      <el-dialog
        class="search-popup"
        :show-close="false"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose">

        <div class="header-style">
          <div class="title-style">
            <span>
              画面設定
            </span>
            <span class="msgDiv">
              {{ diplayMethod == "02" || diplayMethod == "04" ? 8 : 16 }} 件まで設定できます
            </span>
          </div>
          <div style="display: flex;">
            <SpSmartButton class="cancel-button click-item" @click="cancel">
              キャンセル
            </SpSmartButton>
            <narrow-down
              style="margin-left: 16px;"
              @click="handleClickSelect"
            >
              {{ selectRoomList.length }} / {{ diplayMethod == "02" || diplayMethod == "04" ? 8 : 16 }} 選択
            </narrow-down>
          </div>
        </div>

        <el-form
          style="margin-top: 34px;"
          @submit.native.prevent
          :model="query"
          ref="selectMeetingRoomForm" >
          <el-row :gutter="16">
            <el-col class="col" style="display: flex;">
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのビル"
                  v-model="query.buildingId"
                  @change="changeBuild"
                >
                  <el-option
                    v-for="item in buildingList"
                    :key="item.buildingId"
                    :label="item.buildingName"
                    :value="item.buildingId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのフロア"
                  :disabled="query.buildingId == null || query.buildingId == ''"
                  v-model="query.floorId"
                  @change="changeFloor"
                >
                  <el-option
                    v-for="item in filterFloorList"
                    :key="item.floorId"
                    :label="item.floorName"
                    :value="item.floorId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのエリア"
                  v-model="query.areaId"
                  :disabled="query.floorId == null || query.floorId == ''"
                  @change="changeArea"
                >
                  <el-option
                    v-for="item in filterAreaList"
                    :key="item.areaId"
                    :label="item.areaName"
                    :value="item.areaId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="roomName" style="width: 324px !important;">
                <el-input
                  class="input-class"
                  maxlength="50"
                  size="small"
                  placeholder="施設名"
                  v-model="query.roomName">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 検索結果 START -->
        <div class="search-common">
          <el-table
            ref="table"
            show-header
            :data="filterSearchResult"
            @select="handleSelectionChange"
            @select-all="handleSelectionAll">
            <el-table-column
              type="selection"
              prop="roomId"
              class-name="col-2" >
            </el-table-column>
            <!--  ビル名 -->
            <el-table-column
              class-name="col-4"
              prop="buildingName"
              :label="$t('label.system.meetingRoom.search.result.buildingName')"
            >
            </el-table-column>
            <!--  フロア名 -->
            <el-table-column
              class-name="col-4"
              prop="floorName"
              :label="$t('label.system.meetingRoom.search.result.floorName')"
            >
            </el-table-column>
            <!--  エリア名 -->
            <el-table-column
              class-name="col-5"
              prop="areaName"
              :label="$t('label.system.meetingRoom.search.result.areaName')"
            >

            </el-table-column>
            <!--  施設名 -->
            <el-table-column
              class-name="col-5"
              prop="roomName"
              label="施設名"
            >

            </el-table-column>
          </el-table>
        </div>
        <!-- 検索結果 END -->

      </el-dialog>
    </div>

  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import NarrowDown from "@/components/common/generalButton/NarrowDown";

const EVENT_ON_CHECKED = "on-checked";

export default {
  components: {
    SpSmartButton,
    NarrowDown
  },
  props: {
    visible: Boolean,
    selectResourceInfoList: Array,
    diplayMethod: String
  },
  data: function () {
    return {
      searchResultShowFlag: true,
      dialogVisible: this.visible,
      showSelectFloorDialog: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null,
        areaId: null,
        areaName: null,
        roomId: null,
        roomName: null,
      },
      buildingList: [],
      floorList: [],
      areaList: [],
      searchResult: [],
      filterFloorList: [],
      filterAreaList: [],
      filterSearchResult: [],
      selectRoomList: [],
      selectRoomIdList: [],
      filterOptions: {
        build: [],
        floor: [],
        area: [],
        meeting: [],
      },
      model: {
        filterBuildIds: '',
        filterFloorIds: '',
        filterAreaIds: '',
        filterRoomIds: ''
      }
    };
  },
  watch: {
    visible(val) {
      this.searchResult = []
      this.filterSearchResult = []
      this.selectRoomList = []
      this.dialogVisible = val;
      this.getBuildingSearch()
    },
    selectResourceInfoList(val) {
      this.selectRoomIdList = val.map(item => item.resourceId)
      if(this.filterSearchResult && this.filterSearchResult.length >0){
        for (const roomInfo of this.filterSearchResult) {
          if (this.selectRoomIdList.includes(roomInfo.roomId)) {
            this.selectRoomList.push(roomInfo)
            const uniqueArr = this.selectRoomList.filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.roomId === value.roomId
              ))
            );

            this.selectRoomList = uniqueArr
            this.$nextTick(() => {
              this.$refs.table.toggleRowSelection(roomInfo, true);
            });
          }
        }
      }

    },

    "query.roomName": {
      handler() {
        this.loadData()
      }
    },
  },
  methods: {
    changeBuild(val){
      this.query.buildingId = this.$IsNullOrEmpty(val) ? null : val
      this.query.floorId = null
      this.query.areaId = null
      this.query.roomName = null
      this.getFloorSearch()
      this.loadData()
    },
    changeFloor(val){
      this.query.floorId = this.$IsNullOrEmpty(val) ? null : val
      this.query.areaId = null
      this.query.roomName = null
      this.getAreaSearch()
      this.loadData()
    },
    changeArea(val){
      this.query.areaId = this.$IsNullOrEmpty(val) ? null : val
      this.query.roomName = null
      this.loadData()
    },
    handleSelectionAll (selectedRows) {

      let selectedRowsOwnerList = selectedRows.map(item => item.ownerId)

      let newSelectedRowsOwnerList = [ ...new Set(selectedRowsOwnerList)]

      if (newSelectedRowsOwnerList.length > 1) {
        this.$refs.table.clearSelection();
        this.selectRoomList = []
        this.$messageIotError("選択可能な施設は複数オーナから選択できません。");
        return
      }

      if (this.diplayMethod == '02' || this.diplayMethod == '04') {
        if (selectedRows.length > 8) {
          this.$refs.table.clearSelection();
          this.selectRoomList = []
          this.$messageIotError(this.$t("message.common.cmsMeetingRoomError", {field: 8}));
          return
        }
      }

      if (this.diplayMethod == '03') {
        if (selectedRows.length > 16) {
          this.$refs.table.clearSelection();
          this.selectRoomList = []
          this.$messageIotError(this.$t("message.common.cmsMeetingRoomError", {field: 16}));
          return
        }
      }

      for (const selectedRow of selectedRows) {
        if (!this.selectRoomIdList.includes(selectedRow.roomId)) {
          this.selectRoomList.push(selectedRow)
        }
      }

      const currentRoomList = this.selectRoomList.filter(item1 => this.filterSearchResult.some(item2 => item2.roomId == item1.roomId))

      for (const currentRoom of currentRoomList) {
        let selectedRowsRoomIds = selectedRows.map(item => item.roomId)
        if (this.selectRoomIdList.includes(currentRoom.roomId) && !selectedRowsRoomIds.includes(currentRoom.roomId)) {
          const indexToRemove = this.selectRoomList.findIndex(item => item.roomId === currentRoom.roomId);

          if (indexToRemove !== -1) {
            this.selectRoomList.splice(indexToRemove, 1);
          }
        }
      }

      this.selectRoomIdList = this.selectRoomList.map(item => item.roomId)
    },
    handleSelectionChange (selectedRows){

      let selectedRowsOwnerList = selectedRows.map(item => item.ownerId)

      let newSelectedRowsOwnerList = [ ...new Set(selectedRowsOwnerList)]

      if (newSelectedRowsOwnerList.length > 1) {
        this.$refs.table.toggleRowSelection(selectedRows[selectedRows.length - 1], false);
        this.$messageIotError("選択可能な施設は複数オーナから選択できません。");
        return
      }

      if (this.diplayMethod == '02' || this.diplayMethod == '04') {
        if (selectedRows.length > 8) {
          for (let i = 8; i < selectedRows.length; i++) {
            this.$refs.table.toggleRowSelection(selectedRows[i], false);
          }
          this.$messageIotError(this.$t("message.common.cmsMeetingRoomError", {field: 8}));
          return
        }
      }

      if (this.diplayMethod == '03') {
        if (selectedRows.length > 16) {
          for (let i = 16; i < selectedRows.length; i++) {
            this.$refs.table.toggleRowSelection(selectedRows[i], false);
          }
          this.$messageIotError(this.$t("message.common.cmsMeetingRoomError", {field: 16}));
          return
        }
      }

      for (const selectedRow of selectedRows) {
        if (!this.selectRoomIdList.includes(selectedRow.roomId)) {
          this.selectRoomList.push(selectedRow)
        }
      }

      const currentRoomList = this.selectRoomList.filter(item1 => this.filterSearchResult.some(item2 => item2.roomId == item1.roomId))

      for (const currentRoom of currentRoomList) {
        let selectedRowsRoomIds = selectedRows.map(item => item.roomId)
        if (this.selectRoomIdList.includes(currentRoom.roomId) && !selectedRowsRoomIds.includes(currentRoom.roomId)) {
          const indexToRemove = this.selectRoomList.findIndex(item => item.roomId === currentRoom.roomId);

          if (indexToRemove !== -1) {
            this.selectRoomList.splice(indexToRemove, 1);
          }
        }
      }

      this.selectRoomIdList = this.selectRoomList.map(item => item.roomId)
    },
    handleClickSelect(){

      let selectedRowsOwnerList = this.selectRoomList.map(item => item.ownerId)

      let newSelectedRowsOwnerList = [ ...new Set(selectedRowsOwnerList)]

      if (newSelectedRowsOwnerList.length > 1) {
        this.$messageIotError("選択可能な施設は複数オーナから選択できません。");
        return
      }

      if (this.diplayMethod == '02' || this.diplayMethod == '04') {
        if (this.selectRoomList.length > 8) {
          this.$messageIotError(this.$t("message.common.cmsMeetingRoomError", {field: 8}));
          return
        }
      }

      if (this.diplayMethod == '03') {
        if (this.selectRoomList.length > 16) {
          this.$messageIotError(this.$t("message.common.cmsMeetingRoomError", {field: 16}));
          return
        }
      }

      this.dialogVisible = false;
      this.$emit(EVENT_ON_CHECKED, this.selectRoomList);
      this.$emit("update:visible", false);
    },
    getBuildingSearch(){
      SystemManageApi.searchBuilding({
        pageSize: 999,
        pageNumber: 1,
        funcCode: "110100"
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if ("Success" == data.statusCode) {
          this.buildingList = [{buildingId: null, buildingName: ""}]
          for (let bodys of data.body.body) {
            this.buildingList.push({
              buildingId: bodys.buildingId,
              buildingName: bodys.buildingName,
            })
          }

          this.loadData()
        }
      })
    },
    getFloorSearch(){
      SystemManageApi.searchFloor({
        buildingId: this.query.buildingId,
        pageSize: 999,
        pageNumber: 1,
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          this.floorList = [{buildingId: null, buildingName: "", floorId: null, floorName: ""}];
          if (data.body.body.length > 0) {
            for (let bodys of data.body.body) {
              this.floorList.push({
                buildingId: bodys.buildingId,
                buildingName: bodys.buildingName,
                floorId: bodys.floorId,
                floorName: bodys.floorName,
              });
            }
          }

          this.filterFloorList = this.floorList
        })
    },
    getAreaSearch(){
      SystemManageApi.searchArea({
        buildingId: this.query.buildingId,
        floorId: this.query.floorId,
        pageSize: 999,
        pageNumber: 1,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        this.areaList = [{buildingId: null, buildingName: "", floorId: null, floorName: "", areaId: null, areaName: ""}]

        if (data.body.body.length > 0) {
          for (let bodys of data.body.body) {
            this.areaList.push({
              buildingId: bodys.buildingId,
              buildingName: bodys.buildingName,
              floorId: bodys.floorId,
              floorName: bodys.floorName,
              areaId: bodys.areaId,
              areaName: bodys.areaName,
            });
          }
        }

        this.filterAreaList = this.areaList
      })
    },
    loadData(){
      this.searchResult = []

      SystemManageApi.searchMeetingRoom({
        buildingId: this.query.buildingId,
        floorId: this.query.floorId,
        areaId: this.query.areaId,
        roomName: !this.$IsNullOrEmpty(this.query.roomName) ? this.query.roomName : null,
        groupFlg:true,
        pageSize: 9999,
        pageNumber: 1
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if (data.body.body != undefined && data.body.body != null && data.body.body.length > 0) {
          for (const roomInfo of data.body.body) {

            if (roomInfo.deleteFlag) {
              continue
            }

            let buildRoom = this.buildingList.find(item => !this.$IsNullOrEmpty(item.buildingId) && item.buildingId == roomInfo.buildingId)
            if (buildRoom == undefined || buildRoom == null) {
              continue
            }

            this.searchResult.push({
              ownerId: roomInfo.ownerId,
              ownerName: roomInfo.ownerName,
              ownerExId: roomInfo.ownerExId,
              buildingId: roomInfo.buildingId,
              buildingName: roomInfo.buildingName,
              buildingExId: roomInfo.buildingExId,
              floorId: roomInfo.floorId,
              floorName: roomInfo.floorName,
              areaId: roomInfo.areaId,
              areaName: roomInfo.areaName,
              roomId: roomInfo.roomId,
              roomName: roomInfo.groupNum <= 1 ? roomInfo.roomName : (roomInfo.groupSeq < 10 ? roomInfo.roomName + ' ' + '00' + String(roomInfo.groupSeq) : (roomInfo.groupSeq >= 10 && roomInfo.groupSeq < 100) ? roomInfo.roomName + ' '  + '0' + String(roomInfo.groupSeq) : roomInfo.roomName + ' '  + String(roomInfo.groupSeq)),
            })
          }

          if(this.selectResourceInfoList && this.selectResourceInfoList.length > 0){
            this.selectRoomIdList = this.selectResourceInfoList.map(item => item.resourceId)
          }
          this.filterSearchResult = this.searchResult

          for (const roomInfo of this.filterSearchResult) {
            if (this.selectRoomIdList.includes(roomInfo.roomId)) {
              this.selectRoomList.push(roomInfo)
              const uniqueArr = this.selectRoomList.filter((value, index, self) =>
                index === self.findIndex((t) => (
                  t.roomId === value.roomId
                ))
              );

              this.selectRoomList = uniqueArr
              this.$nextTick(() => {
                this.$refs.table.toggleRowSelection(roomInfo, true);
              });
            }
          }
        } else {
          this.filterSearchResult = []
        }
      })

      // SystemManageApi.OutlookMeetingRoomSearch({
      //   buildingId: this.query.buildingId,
      //   floorId: this.query.floorId,
      //   areaId: this.query.areaId,
      //   roomName: !this.$IsNullOrEmpty(this.query.roomName) ? this.query.roomName : null,
      //   groupFlg:true,
      //   pageSize: 9999,
      //   pageNumber: 1
      // })
      // .catch((error) => {
      //   errorCodeMsg(error, this)
      // })
      // .then(({ data }) => {
      //   if (data.body.body != undefined && data.body.body != null && data.body.body.length > 0) {
      //     for (const roomInfo of data.body.body) {

      //       if (roomInfo.deleteFlag) {
      //         continue
      //       }

      //       let buildRoom = this.buildingList.find(item => !this.$IsNullOrEmpty(item.buildingId) && item.buildingId == roomInfo.buildingId)
      //       if (buildRoom == undefined || buildRoom == null) {
      //         continue
      //       }

      //       this.searchResult.push({
      //         ownerId: roomInfo.ownerId,
      //         ownerName: roomInfo.ownerName,
      //         ownerExId: roomInfo.ownerExId,
      //         buildingId: roomInfo.buildingId,
      //         buildingName: roomInfo.buildingName,
      //         buildingExId: roomInfo.buildingExId,
      //         floorId: roomInfo.floorId,
      //         floorName: roomInfo.floorName,
      //         areaId: roomInfo.areaId,
      //         areaName: roomInfo.areaName,
      //         roomId: roomInfo.roomId,
      //         roomName: roomInfo.groupNum <= 1 ? roomInfo.roomName : (roomInfo.groupSeq < 10 ? roomInfo.roomName + ' ' + '00' + String(roomInfo.groupSeq) : (roomInfo.groupSeq >= 10 && roomInfo.groupSeq < 100) ? roomInfo.roomName + ' '  + '0' + String(roomInfo.groupSeq) : roomInfo.roomName + ' '  + String(roomInfo.groupSeq)),
      //       })
      //     }
      //   }
      // })

    },
    cancel () {
      this.handleDialogClose()
    },

    // Dialog閉じる
    handleDialogClose () {
      this.buildingList = []
      this.floorList = []
      this.areaList = []
      this.searchResult = []
      this.filterFloorList = []
      this.filterAreaList = []
      this.filterSearchResult = []
      this.selectResourceInfoList = []
      this.query = {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null,
        areaId: null,
        areaName: null,
        roomId: null,
        roomName: null,
      }
      this.dialogVisible = false
      this.$emit("update:visible", false)
    },

  }
};
</script>

<style lang="scss" scoped>
.search-popup {
  ::v-deep  .el-dialog {
    min-width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}


.viewable-area-style ::v-deep .el-dialog {
  padding-top: 0px !important;
}
.header-style {
  margin-top: 34px;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}

.m-r-16 {
  margin-right: 16px;
}
.title-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  color: #525250;
  display: flex;
  align-items: center;
}
.img-div {
  width: 410px;
  height: 229px;
  left: 542px;
  gap: 0px;
  border-radius: 8px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
}
.msgDiv {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 14px;
  font-weight: 300;
  line-height: 28px;
  text-align: left;
  margin-left: 32px;
}
</style>
